const COLORS = {
  blue: "#5176A1",
  beige: "#E4D7CD",
};

export default COLORS;
